import { Typography } from 'antd';
import styled from 'styled-components';

export const AllDayEventWrapper = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  width: 100%;
  max-width: 100%;
  display: flex;
  padding: 2px 4px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
`;

export const TextWrapper = styled(Typography.Text)<{ $isCompleted: boolean }>`
  color: ${({ theme, $isCompleted }) => ($isCompleted ? theme.colors.black6 : theme.colors.black9)};
`;
